import React from "react";
// @ts-ignore
import {
  Route,
  BrowserRouter as Router,
  Routes,
  Navigate,
  Outlet,
  useParams,
} from "react-router-dom";
import OtpVerify from "../components/Login/OtpVerify";
import LoginByOtp from "../components/Login/LogInByOtp";
import LogInByPassword from "../components/Login/LogInByPassword";
import SetPassword from "../components/Login/SetPassword";
import MeetingList from "../components/Meeting/MeetingList";
import ActionList from "../components/Action/ActionList";
import Alert from "../components/Setting/Alert/Alert";
import MeetingRoom from "../components/Setting/MeetingRoom/MeetingRoom";
import Employee from "../components/Setting/Employee/Employee";
import Configuration from "../components/Setting/Configuration/Configuration";
import Organization from "../components/Setting/Organization/Organization";
import OrganizationNew from "../components/Setting/Organization/OrganizationNew";
import Unit from "../components/Setting/Unit/Unit";
import Department from "../components/Setting/Department/Department";
import Designation from "../components/Setting/Designation/Designation";
import MeetingPage from "../components/Meeting/MeetingPage";
import { ToastContainer } from "react-toastify";
import ViewMeetingDetails from "../components/Meeting/ViewMeetingDetails";
import EditMeetingPage from "../components/Meeting/EditMeetingPage";
import MinutesPage from "../components/Minutes/MinutesPage";
import ViewActionPage from "../components/Action/ViewActionPage";
import ViewMinutePage from "../components/Minutes/ViewMinutePage";
import TimelinePage from "../components/Timeline/TimelinePage";
import ViewNotification from "../components/Notification/ViewNotification";
import PageNotFound from "../components/Common/PageNotFound";
import ActivityLogs from "../components/ActivityLogs/ActivityLogs";
import LandingPage from "../components/LandingPage/LandingPage";
import LandingPage2 from "../components/LandingPage/LandingPage2";
import PrivacyPolicy from "../components/LandingPage/PrivacyPolicy";
import TermConditions from "../components/LandingPage/TermConditions";
import GoogleAuth from "../components/Login/LoginByGoogle";
import Addhostdetails from "../components/Setting/HostingDetails/Addhostdetails";
import OrganizationRegistration from "../components/Setting/Organization/OrganizationRegistration";
import FullActionStatisticsDetails from "../components/Action/FullActionStatisticsDetails";
import SingleSignIn from "../components/Login/SingleSignIn";
import Sidebar from "../components/Common/Sidebar/Sidebar";
import Header from "../components/Common/Header/Header";
import EmailLogs from "../components/EmailActivityLogs/EmailActivitylogs";
import EmailTemplate from "../components/Setting/EmailTemplate/EmailTemplate";
import SmtpSetUpClient from "../components/Setting/SmtpSetUp/SmtpSetUpClient";
///////////pratishruti///////////
import AdminPanelLogin from "../components/AdminPanel/AdminPanelLoginByOtp";
import AdminLoginByPassword from "../components/AdminPanel/AdminLoginByPassword";
import AdminSetPassword from "../components/AdminPanel/AdminSetPassword";
import Leads from "../components/AdminPanel/Leads";
import Registration from "../components/AdminPanel/Registration/Registration";
import SubscriptionModule from "../components/AdminPanel/SubscriptionModule";
import AdminEmailLogs from "../components/AdminPanel/EmailLogs";
import AdminEmailTemplate from "../components/AdminPanel/EmailTemplate/EmailTemplate";
///////////pratishruti///////////
const PrivateRoutes = () => {
  const currentPath = window.location.pathname;
  let accessToken = localStorage.getItem("accessToken");
  const userData = JSON.parse(localStorage.getItem("userData") || "{}");
  const isSuperAdmin = userData?.isSuperAdmin;

  return accessToken ? (
    <>
      {!isSuperAdmin && (
        <>
          <Header />
          <Sidebar />
        </>
      )}
      <Outlet />
    </>
  ) : (
    <Navigate to="/login" state={{ currentPath }} />
  );
};

const AuthRoutes = () => {
  let paramDatas = useParams();
  const isRememberMe = localStorage.getItem("rememberMe");
  let accessToken = localStorage.getItem("accessToken");

  if (accessToken) {
    let userData = JSON.parse(localStorage.getItem("userData") || "{}");
    return userData?.isSuperAdmin ? (
      <Navigate to="/leads" state={{ paramDatas }} />
    ) : (
      <Navigate to="/meeting-list" state={{ paramDatas }} />
    );
  }
  return !isRememberMe ? (
    <Outlet />
  ) : (
    <Navigate to="/meeting-list" state={{ paramDatas }} />
  );
};

const MainRoute = () => {
  return (
    <div>
      <Router>
        <Routes>
          <Route element={<PrivateRoutes />}>
            <Route exact path="/meeting-list" element={<MeetingList />} />
            <Route exact path="/action-list" element={<ActionList />} />
            <Route exact path="/organization" element={<OrganizationNew />} />
            <Route exact path="/unit" element={<Unit />} />
            <Route exact path="/department" element={<Department />} />
            <Route exact path="/designation" element={<Designation />} />
            <Route exact path="/employee" element={<Employee />} />
            <Route exact path="/meeting-room" element={<MeetingRoom />} />
            <Route exact path="/alerts" element={<Alert />} />
            <Route exact path="/configuration" element={<Configuration />} />
            <Route exact path="/create-meeting" element={<MeetingPage />} />
            <Route exact path="/edit-meeting" element={<EditMeetingPage />} />
            <Route exact path="/activity-logs" element={<ActivityLogs />} />
            <Route exact path="/email-activity-logs" element={<EmailLogs />} />
            <Route exact path="/hosting-details" element={<Addhostdetails />} />
            <Route exact path="/email-template" element={<EmailTemplate />} />
            <Route
              exact
              path="/smtp-configuration"
              element={<SmtpSetUpClient />}
            />

            <Route
              exact
              path="/statistics-details/:organizationId"
              element={<FullActionStatisticsDetails />}
            />
            <Route
              exact
              path="/write-minute/:meetingId"
              element={<MinutesPage />}
            />
            <Route
              exact
              path="/edit-meeting/:meetingId"
              element={<MinutesPage />}
            />
            <Route
              exact
              path="/view-action-detail/:id"
              element={<ViewActionPage />}
            />
            <Route
              exact
              path="/view-minute-detail/:meetingId"
              element={<ViewMinutePage />}
            />
            <Route exact path="/notification" element={<ViewNotification />} />

            <Route
              exact
              path="/create-followon/:meetingId"
              element={<TimelinePage />}
            />
            <Route
              exact
              path="/view-meeting-details/:id"
              element={<ViewMeetingDetails />}
            />
            <Route exact path="/leads" element={<Leads />} />
            <Route exact path="/leads" element={<Leads />} />
            <Route exact path="/registration" element={<Registration />} />
            <Route
              exact
              path="/subscription"
              element={<SubscriptionModule />}
            />
            <Route
              exact
              path="/admin-emailtemplate"
              element={<AdminEmailTemplate />}
            />
            <Route exact path="/admin-emaillogs" element={<AdminEmailLogs />} />
            {/* Pratishruti */}
          </Route>

          <Route element={<AuthRoutes />}>
            <Route exact path="/" element={<LandingPage />} />
            <Route exact path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route exact path="/term-conditions" element={<TermConditions />} />
            <Route exact path="/LandingPage2" element={<LandingPage2 />} />
            {/* <Route exact path="/smtp-configuration" element={<SmtpSetUpClient />} /> */}
            <Route
              exact
              path="/organization-registration"
              element={<OrganizationRegistration />}
            />
            <Route
              exact
              path="/login"
              element={<LoginByOtp />}
              title="LoginByOtp"
            />
            <Route
              exact
              path="/login/:meetingId/:rsvp/:userId"
              element={<LoginByOtp />}
            />
            <Route exact path="/otp-verify" element={<OtpVerify />} />
            <Route
              exact
              path="/log-in-by-otp"
              element={<LoginByOtp />}
              title="LoginByOtp"
            />
            <Route exact path="/redirect/:token" element={<SingleSignIn />} />

            <Route
              exact
              path="/log-in-by-google"
              element={<GoogleAuth />}
              title="GoogleAuth"
            />
            <Route exact path="/otp-verify" element={<OtpVerify />} />
            <Route
              exact
              path="/organization-registration"
              element={<OrganizationRegistration />}
            />

            <Route
              exact
              path="/login-by-password"
              element={<LogInByPassword />}
            />

            <Route exact path="/set-password" element={<SetPassword />} />
          </Route>
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </Router>
      <ToastContainer />
    </div>
  );
};

export default MainRoute;
